// A supplier pick/save carries evidence. Typing a number only preserves the
// operator's price; it does not verify that amount against a supplier.
import { manualPriceSource } from "./priceProvenance.js";

const isObj = (v) => !!v && typeof v === "object" && !Array.isArray(v);

export function patchCarriesSource(patch) {
  return isObj(patch) && isObj(patch._price_source);
}

export function patchMaterialRow(before, patch) {
  const prev = isObj(before) ? before : {};
  const p = isObj(patch) ? patch : {};
  const next = { ...prev, ...p };
  if (patchCarriesSource(p)) {
    // A real supplier pick/save or explicit source correction supersedes a
    // previous numeric pin without touching the amount unless it supplies one.
    if (!Object.prototype.hasOwnProperty.call(p, "_pinCost")) delete next._pinCost;
    delete next._pinKind;
    delete next._pinOrigin;
    return next;
  }
  const hasCost = Object.prototype.hasOwnProperty.call(p, "our_cost");
  const validCost = p.our_cost !== "" && p.our_cost != null && Number.isFinite(Number(p.our_cost)) && Number(p.our_cost) >= 0;
  const changedCost = p.our_cost === "" ? prev.our_cost !== "" : validCost && (prev.our_cost === "" || Number(p.our_cost) !== Number(prev.our_cost));
  if (hasCost && changedCost) {
    next._tech_edit = true; // durable protection against learned price rules
    next._price_source = manualPriceSource(prev._price_source, prev.our_cost);
    next._pinCost = validCost;
  }
  return next;
}
